import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-invoice-warning-info',
  templateUrl: './invoice-warning-info.component.html',
  styleUrls: ['./invoice-warning-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceWarningInfoComponent {
  @Input() messageKey!: string;
  @Input() questionKey?: string;

  @Input() params?: Record<string, any>;

  @Output() noClicked = new EventEmitter<void>();
  @Output() finishClicked = new EventEmitter<void>();
}
